import { applicationCountries } from '@/shared/tools/applicationCountries'
import PropTypes from 'prop-types'
import CountryFlag from '@/shared/components/CountryFlag/CountryFlag'

const ApplicationCountry = ({ country, floating = false }) => {
  const flag = applicationCountries[country] || ''
  if (!flag) return null

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexShrink: 0,
        height: floating ? '1.6875rem' : '10px',
        marginBottom: floating ? 0 : '2rem',
      }}
    >
      <CountryFlag country={country} />
    </div>
  )
}

ApplicationCountry.propTypes = {
  country: PropTypes.string.isRequired,
  floating: PropTypes.bool,
}

export default ApplicationCountry
